module.exports = __webpack_public_path__ + "static/media/herobg2.9a578e63.gif";